import React from 'react';
import './styles.css';
import i18n from '../../translate/i18n';

//COMPONENTS
import Template from '../../components/Template';
import WidgetChartLine from '../../components/Widgets/WidgetChartLine';
import WidgetCard from '../../components/Widgets/WidgetCard';
import WidgetFilterMonth from '../../components/Widgets/WidgetFilterMonth';


export default function FinancialDashboard() {

  return (
    <Template path={i18n.t('menu.financial control')}>
      <div className='container' id='controle-financeiro'>

        <div className="col-md-12">
          <div className="row justify-content-md-end">
            <div className="col-md-6">
              <WidgetFilterMonth />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <WidgetCard
                title={'Custo total'}
                value={'R$70.456,45'}
                percentual={'2.5%'}
                info={'Comparado a (R$69.856,23 mês anterior)'}
              />
            </div>
            <div className="col-md-6">
              <WidgetCard
                title={'Valores não indenizados'}
                value={'R$40.547,45'}
                percentual={'2.5%'}
                info={'Comparado a (R$39.458,42 mês anterior)'}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <WidgetChartLine title='Parceiro 1' />
            </div>
            <div className="col-md-6">
              <WidgetChartLine title='Parceiro 2' />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <WidgetChartLine title='Parceiro 3' />
            </div>
            <div className="col-md-6">
              <WidgetChartLine title='Parceiro 4' />
            </div>
          </div>
        </div>
      </div>
    </Template>
  )
}
